<template>
  <!-- tab 休息日 -->
 <!-- <div style="height: 560px;display:flex;overflow-y:scroll;"> -->
    <div class="theDayCalenDarBox">
      <div style="display:flex">
        <div class="titleDay">
          <i class="el-icon-arrow-left" @click="changYear(0)"></i>
          <el-date-picker v-model="year" type="year" :clearable="false" :placeholder="this.$t('input_113')">
          </el-date-picker>
          <i class="el-icon-arrow-right" @click="changYear(1)"></i>
        </div>
        <div class="buttonBox">
          <div>
            <div class="chooseButton searchButton" v-if="showButton" @click="acquiescence"><i
                class="el-icon-refresh"></i>默认
            </div>
            <div class="chooseButton searchButton" @click="checkedAll"><i class="el-icon-circle-plus-outline"></i>全选
            </div>
            <div class="chooseButton searchButton" @click="checkedUnAll"><i class="el-icon-edit-outline"></i>反选
            </div>
            <div class="chooseButton reSetButton" @click="save" v-if="MenuRoleList.indexOf('103')>=0"><i
                class="el-icon-finished"></i>{{$t('btn_13')}}
            </div>
          </div>
        </div>
      </div>
      <div class="calenPart">
        <calendarPart v-for="(mouth,index) in mouths" :key="index" ref="mouth" :mouth="mouth"
          :calendar-optiond-day="calendarOptiondDay" @checkedDate="checkedDate" @checkedAll="checkedAll"
          @selectDay="onClick"></calendarPart>
      </div>
    </div>
 <!-- </div> -->
</template>
<script>
  import calendarPart from "@/components/list/calendar/calendarPage";
  import moment from 'moment'
  export default {
    name: 'CalendarDemo',
    components: {
      calendarPart
    },
    props: {
      calendarData: {
        type: Array,
        default: []
      },
      showButton: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        year: moment().format('YYYY'),
        mouths: [],
        checkedDates: [], // 最终选中的全部日期
        calendarOptiondDay: [], //选中日期数组
        allCheckDay: [],
        MenuRoleList: [],
      }
    },
    watch: {
      calendarData(val) {
        if (val.length > 0) {
          let monthxx = this.mouths;
          for (var i = 0; i < this.mouths.length; i++) {
            this.$refs.mouth[i].checkAll(val);
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.changeYear(this.year)
      })
    },
    methods: {
      save: function() {
        this.$emit('saveRest', {
          restDay: this.checkedDates,
          year: this.year
        });
      },
      acquiescence: function() {
        this.$emit('acquiescenceRest', {
          year: this.year
        });
      },
      changYear(index) {
        let NewYear = ''
        if (index == 1) {
          NewYear = Number(this.year) + 1;
        } else {
          NewYear = Number(this.year) - 1;
        }
        this.year = NewYear.toString();
        this.$emit('selectRest', {
          year: NewYear.toString()
        });
        this.changeYear(this.year)
      },
      checkedAll(checkDayObj) {
        let monthxx = this.mouths;
        for (var i = 0; i < this.mouths.length; i++) {
          this.$refs.mouth[i].checked();
        }
      },
      checkedUnAll(checkDayObj) {
        let monthxx = this.mouths;
        for (var i = 0; i < this.mouths.length; i++) {
          this.$refs.mouth[i].unChecked();
        }
      },
      formatDate(time) {
        var date = new Date(time);
        var time1 = moment(date).format("YYYY");
        return time1; //年月日 格式自己定义 'yyyy : MM : dd' 例 2018年12月5日的格式
      },
      changeYear(val) {
        this.year = moment(val + '').format('YYYY')
        this.choseWorkDay = ''
        this.choseCheckAll = false
        this.mouths = []
        for (let i = 1; i <= 12; i++) {
          if (i < 10) {
            this.mouths.push(this.year + '-' + '0' + i)
          } else {
            this.mouths.push(this.year + '-' + i)
          }
        }

      },
      onClick(day) {
        if (day.select) day.select = false
        else day.select = true
      },
      check(work, noWork) {
        // 选择工作日、非工作日、全选、全不选后，先清空选中项，再添加选中数据
        this.checkedDates = []
        this.mouths.forEach(mouth => {
          this.$refs[mouth][0].checkWork(true, work)
          this.$refs[mouth][0].checkWork(false, noWork)
        })
      },
      // 获取--最终--全部选中的数据
      checkedDate(checkDayObj) {
        if (this.allCheckDay && this.allCheckDay.length > 0) {
          const mouthObj = this.allCheckDay.findIndex((mouthDay) => mouthDay.mouth === checkDayObj.mouth)
          if (mouthObj !== -1) {
            this.allCheckDay[mouthObj].checkedDay = checkDayObj.checkedDay
          } else this.allCheckDay.push(checkDayObj)
        } else this.allCheckDay.push(checkDayObj)
        this.checkedDates = []
        this.allCheckDay.forEach(mouth => {
          this.checkedDates = [...this.checkedDates, ...mouth.checkedDay]
        })
        /**
         * 日期列表转化字符串
         * cDatelist为最终list，按需要转化
         * 例：["2019-01-01", "2019-01-02", "2019-01-03", "2019-01-04", "2019-01-05"]
         */
        const checkedDates = [...this.checkedDates]
        const cDatelist = []
        checkedDates.forEach(val => {
          cDatelist.push(val.date)
        })
      },
      changeWorkDay(value) {
        this.choseCheckAll = false
        if (value) {
          if (value === '工作日') {
            this.check(true, false)
          } else if (value === '非工作日') {
            this.check(false, true)
          }
        }
      },
      changeCheckAll(value) {
        this.checkedAll()
      }
    },
    created() {
      this.MenuRoleList = this.$store.getters.getMenu;
    }
  }
</script>
<style>
  .theDayCalenDarBox .el-input__icon.el-icon-date {
    display: none;
  }

  .theDayCalenDarBox .el-input__inner {
    background: none;
    background-color: none;
    border: none;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/restDay.vue